import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ShopTypePickerBlockConfig } from '@front-platform/content-builder';
import { shopTypePickerBlockResolveConfig } from '@front-platform/content-builder';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Component, input } from '@angular/core';

import { DoodEntityCategory } from '@core/models/entity.model';
import { EntitiesService } from '@core/services/entities/entities.service';
import { FilterStoreDispatcher } from '@common/dispatchers/filter.dispatcher';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
export interface ShopTypePickerBlockRuntimeConfig {
  'display_on_desktop'?: boolean;
}

export type ShopTypePickerBlockConfigInput = Partial<
  Omit<ShopTypePickerBlockConfig, keyof ShopTypePickerBlockRuntimeConfig> &
    ShopTypePickerBlockRuntimeConfig
>;
export type ShopTypePickerBlockResolvedConfig = Omit<
  ShopTypePickerBlockConfig,
  keyof ShopTypePickerBlockRuntimeConfig
> &
  Partial<ShopTypePickerBlockRuntimeConfig>;
export interface ShopTypePickerBlockContract extends ConfigComponentContract<
  ShopTypePickerBlockConfigInput,
  ShopTypePickerBlockResolvedConfig
> {}

@Component({
  selector: 'app-shop-type-picker-block',
  templateUrl: './shop-type-picker-block.component.html',
  standalone: false,
})
export class ShopTypePickerBlockComponent implements ShopTypePickerBlockContract {
  readonly config = input<ShopTypePickerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ShopTypePickerBlockConfig,
    ShopTypePickerBlockRuntimeConfig
  >(shopTypePickerBlockResolveConfig, () => ({ config: this.config() }));
  get displayOnDesktop(): boolean {
    const value = this.resolvedConfig()['display_on_desktop'];
    return value === undefined ? true : (value as unknown as boolean);
  }

  marketplaceId$: Observable<string> = this.marketplaceSelector.selectMarketplaceId$;

  categoryItems!: DoodEntityCategory[];

  constructor(
    private filterDispatcher: FilterStoreDispatcher,
    private readonly entitiesService: EntitiesService,
    private marketplaceSelector: MarketplaceStoreSelector,
  ) {
    this.marketplaceId$
      .pipe(
        take(1),
        switchMap(id => this.entitiesService.loadEntitiesCategories$(id)),
      )
      .subscribe(result => (this.categoryItems = result));
  }

  selectCategory(category: DoodEntityCategory): void {
    this.filterDispatcher.addCategory(category);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ShopTypePickerBlockComponent, { 'keyAliases': {} });
